import Header from '../navigation/headerContainer';
import Footer from '../navigation/footerContainer';
import LoginForm from './loginForm';

export default function LoginPage() {

    return (
        <>
            <Header />
            <LoginForm />
            <Footer />
        
        </>
    );

}